import type { StageResponse } from "../services/ProposalGenerationServices";

/**
 * Navigate to a specific stage in the proposal generation workflow
 * @param history - React Router history object
 * @param runId - The proposal generation run ID
 * @param stages - Array of stage data
 * @param targetDialogueId - The dialogue ID to navigate to
 * @param stageNumber - The stage number to navigate to
 * @param logPrefix - Optional prefix for console logs (for debugging)
 */
export const navigateToStage = (
  history: any,
  runId: number | undefined,
  stages: StageResponse[] | undefined,
  targetDialogueId: number,
  stageNumber: number | undefined,
  logPrefix = "[navigateToStage]",
): void => {
  console.log(`${logPrefix} called`, {
    targetDialogueId,
    stageNumber,
    runId,
    historyAvailable: !!history,
  });

  // Validate required parameters
  if (!runId || stageNumber === undefined) {
    console.log(`${logPrefix} Missing required params for stage navigation`);
    return;
  }

  if (!history) {
    console.error(`${logPrefix} History object not available`);
    return;
  }

  // Find the clicked stage to check its status
  const clickedStage = stages?.find((s) => s.sequence_number === stageNumber);

  if (!clickedStage) {
    console.log(`${logPrefix} Stage not found`);
    return;
  }

  // If stage is pending, navigate to splash page for configuration
  if (clickedStage.status === "pending") {
    const targetUrl = `/proposal-generation?runId=${runId}&stageNumber=${stageNumber}`;
    console.log(`${logPrefix} Stage is pending, navigating to splash:`, targetUrl);
    history.push(targetUrl);
  } else {
    // Otherwise navigate to chat page for that stage
    const targetUrl = `/proposal-generation/chat/${runId}/${targetDialogueId}`;
    console.log(`${logPrefix} Stage not pending, navigating to chat:`, targetUrl);
    history.push(targetUrl);
  }
};
